import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
// const ics = require('ics')
// const {google} = require('googleapis');
// import Login from './login/login.component.jsx';
import Signup from '../login/signup';
import Signin from '../login/login';
import Forgot from '../common/forgotPassword';
import ActivateAccount from '../common/accountActivation';
import ResetPassword from '../common/resetPassword'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from '../marketing/home';
import Blog from '../marketing/blog';
import UnLockAccount from '../common/unlockAccount';
import UnsubscribeEmails from '../common/unsubscribeEmails';
import OtpModal from '../login/otp';
import openSocket from "socket.io-client";
import * as url from "../../tools/config";
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
import { Form, Button, Col, Container, Row, Modal, Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClinicMedical, faUserMd, faIdCard,faUserCheck } from "@fortawesome/free-solid-svg-icons";
import ReactFlagsSelect from 'react-flags-select';




class SpecialistRequirements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countryWiseTabkey: 'bangladesh',
            signUpModelOpen: false,
            viewRequirementsByBangladesh: true,
            viewRequirementsByUK: false,
            viewRequirementsByIndia: false,
            signInModelOpen: false,
            activateAccountModalOpen: false,
            resetModalOpen: false,
            isLoader: true,
            isHome: false,
            isBlog: false,
            howItWork: false,
            issearchSpeciality: false,
            resetkey: '',
            activationKey: '',
            emailToken: '',
            unLockAccountModalOpen: false,
            unSubscribeEmailModalOpen: false,
            unlockKey: '',
            key: '',
            adminAuth: false,
            otpModalOpen: false,
            loginData: {},

        };
        this.openSignInModal = this.openSignInModal.bind(this);
        this.hideSigninModal = this.hideSigninModal.bind(this);
        this.openSignUpModal = this.openSignUpModal.bind(this);
        this.hideSignupModal = this.hideSignupModal.bind(this);
        this.closeSignupOpenSignin = this.closeSignupOpenSignin.bind(this);
        this.closeSigninOpenSignup = this.closeSigninOpenSignup.bind(this);
        this.openForgotModal = this.openForgotModal.bind(this);
        this.openOtpModal = this.openOtpModal.bind(this);
        this.closeOtpModal = this.closeOtpModal.bind(this);
        this.hideForgotModal = this.hideForgotModal.bind(this);
        this.closeForgotModal = this.closeForgotModal.bind(this);
        this.closeActivateOpenSigin = this.closeActivateOpenSigin.bind(this);
        this.closeResetOpenSigin = this.closeResetOpenSigin.bind(this);
        this.closeActive = this.closeActive.bind(this);
        this.closeReset = this.closeReset.bind(this);
        this.openBlog = this.openBlog.bind(this);
        this.openHome = this.openHome.bind(this);
        this.openUnLockAccountModal = this.openUnLockAccountModal.bind(this);
        this.openUnsubscribeModal = this.openUnsubscribeModal.bind(this);

        this.closeUnLockAccountModal = this.closeUnLockAccountModal.bind(this);
        this.closeUnsubscribeModal = this.closeUnsubscribeModal.bind(this);

        this.closeUnLockAccountOpenSigin = this.closeUnLockAccountOpenSigin.bind(this);
        this.goToSpecialistSearch = this.goToSpecialistSearch.bind(this);
        this.howItWorkEnable = this.howItWorkEnable.bind(this);



    }

    goToSpecialistSearch() {
        navigator.geolocation.getCurrentPosition(
            function (position) { // success cb
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                localStorage.setItem('lat', lat);
                localStorage.setItem('lng', lng);
            },
            function () { // fail cb
                localStorage.setItem('lat', 0);
                localStorage.setItem('lng', 0);
            }
        );
        this.setState({
            isHome: false
        })
        this.props.history.push('/marketing/search-specialist');
    }
    openBlog() {
        this.setState({ isBlog: true, isHome: false })
    }
    openHome() {
        this.setState({ isBlog: false, isHome: false, howItWork: false })
    }

    componentWillMount() {
        var user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
        var userId = localStorage.getItem("userId") ? localStorage.getItem("userId") : {};
    


        // debugger;
        if (!user && !userId) {
            this.props.history.push('/')
        } else {
            console.log("+++...useridfd", user, userId)
            // socket.emit("adduser", { userId  });
        }
        if (this.props.location.pathname == '/') {
            if (user.type === 'patient')
                this.props.history.push('/dashboard')
            if (user.type === 'specialist')
                this.props.history.push('/specialist/my-appointment')
            if (user.role_id && user.role_id.status == 3)
                this.props.history.push('/user/superuser-dashboard')
        }
        if (this.props.match.params.activationKey) {

            this.setState({ activateAccountModalOpen: true, activationKey: this.props.match.params.activationKey })
        } else if (this.props.match.params.resetkey) {
            this.setState({ resetModalOpen: true, resetkey: this.props.match.params.resetkey })
        } else if (this.props.match.params.emailToken) {

            this.setState({ signInModelOpen: true, emailToken: this.props.match.params.emailToken });

        } else if (this.props.match.params.unlockKey) {
            this.setState({ unLockAccountModalOpen: true, unlockKey: this.props.match.params.unlockKey });
        }
        else if (this.props.match.params.key) {
            this.setState({ unSubscribeEmailModalOpen: true, key: this.props.match.params.key });
        }/* else if(user != null){
			this.props.history.push('/dashboard')
			// <Redirect to="/dashboard" />
		} */

    }
    componentDidMount() {

        this.setState({ isLoader: false });
        localStorage.setItem('isDisclaimerBlog', true);

        if (localStorage.getItem('availabilityId') && (localStorage.getItem('availabilityId') != null && localStorage.getItem('availabilityId') != '') && localStorage.getItem('fromMarketPage') && (localStorage.getItem('fromMarketPage') != null && localStorage.getItem('fromMarketPage') != false)) {
            this.setState({ signInModelOpen: true });

        }
        // navigator.geolocation.getCurrentPosition(
        //     function (position) {

        //         var lat = position.coords.latitude;
        //         var lng = position.coords.longitude;

        //         localStorage.setItem('lat', lat);
        //         localStorage.setItem('lng', lng);
        //         axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
        //             .then(function (response) {
        //                 if (response) {

        //                     for (var i = 0; i < response.data.results.length; i++) {
        //                         if (response.data.results[i].types[0] == 'country') {
        //                             var countryshort = response.data.results[i].address_components[0].short_name;
        //                             var countrylong = response.data.results[i].address_components[0].long_name;


                                  





        //                             localStorage.setItem('country_short', countryshort)
        //                             localStorage.setItem('country_long', countrylong)
        //                             localStorage.setItem('Currentcountry', countrylong)

        //                             localStorage.setItem('currency', countries[countryshort].currencies[0]);
        //                             localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
        //                             localStorage.removeItem('mileDistance', 0)
        //                         }
        //                     }

                    

        //                 }
                       
        //             })
        //     });
    }

    openSignUpModal(userType) {
        localStorage.setItem('userType', userType)
        this.setState({ signUpModelOpen: true })
    }
    hideSignupModal(e) {
        this.setState({ signUpModelOpen: false });
        // e.preventDefault()

    }

    openSignInModal(userType) {
        localStorage.setItem('userType', userType)
        this.setState({ signInModelOpen: true });
    }
    hideSigninModal() {
        this.setState({ signInModelOpen: false });
        localStorage.removeItem('fromMarketPage');
    }
    closeSignupOpenSignin() {
        this.setState({ signUpModelOpen: false, signInModelOpen: true }, () => {

        })
    }
    closeSigninOpenSignup() {
        this.setState({ signUpModelOpen: true, signInModelOpen: false }, () => {

        })
    }
    openForgotModal() {

        this.setState({ forgotModalOpen: true, signInModelOpen: false });
    }

    closeForgotModal() {
        this.setState({ forgotModalOpen: false, signInModelOpen: true });
    }
    openOtpModal(data) {
        // debugger
        this.setState({ otpModalOpen: true, signInModelOpen: false, loginData: data }, () => {

        });
    }
    closeOtpModal() {
        this.setState({ otpModalOpen: false, signInModelOpen: false });
    }
    hideForgotModal() {
        this.setState({ forgotModalOpen: false });

    }
    closeActivateOpenSigin() {
        this.setState({ signInModelOpen: true, activateAccountModalOpen: false }, () => {

        })
    }
    closeResetOpenSigin() {
        this.setState({ resetModalOpen: false })
        this.props.history.push('/')
    }
    closeActive() {
        this.setState({ activateAccountModalOpen: false })
        this.props.history.push('/');
    }
    closeReset() {
        this.setState({ resetModalOpen: false })
        this.props.history.push('/')
    }

    openUnLockAccountModal() {
        this.setState({ unLockAccountModalOpen: true });
    }
    openUnsubscribeModal() {
        this.setState({ unSubscribeEmailModalOpen: true });
    }
    closeUnLockAccountModal() {
        this.setState({ unLockAccountModalOpen: false })
        this.props.history.push('/');
    }
    closeUnsubscribeModal() {
        this.setState({ unSubscribeEmailModalOpen: false })
        this.props.history.push('/');
    }
    closeUnLockAccountOpenSigin() {
        this.setState({ signInModelOpen: true, unLockAccountModalOpen: false })
    }
    howItWorkEnable() {
        this.setState({ howItWork: true, isHome: false });
    }

    onTabSelection = (e) => {
        this.setState({ countryWiseTabkey: e });
        
        if (e == 'bangladesh') {
			this.setState({ viewRequirementsByBangladesh: true });
		} else if (e == 'unitedKingdom') {
			this.setState({ viewRequirementsByUK: true });
		} else if (e == 'india') {
			this.setState({ viewRequirementsByIndia: true });
		}
	
	}


    render() {
        let bangladeshTabTitle = <span>Bangladesh</span>
        let unitedKingdomTabTitle = <span>United Kingdom</span>
		let indiaTabTitle = <span>India</span>


        return <div>
            {this.state.isLoader ? <ReactLoading type={'bars'} color={'blue'} /> :
                <div>
                    <nav className="navbar navbar-expand-md  navbar-default fixed-top navbar-fixed-top sticky">
                        <Link to="/" className="navbar-brand logo" href="#">
                            <img src={require('../../images/images/logo.svg')} width="185" alt="" />
                        </Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"><i className="fa fa-align-justify"></i></span>
                        </button>

                        <div className="collapse navbar-collapse flex-row-reverse" id="navbarSupportedContent">
                            <ul className=" navbar-nav navbar-right ">
                                <li
                                    className={(this.state.isHome) ? 'nav-item active' : 'nav-item'} style={{ 'cursor': 'pointer' }}
                                >
                                    <Link /* onClick={this.openHome} */ to="/" onClick={this.ICS}>Home</Link>
                                </li>
                                {/* <li className={(this.state.howItWork) ? 'nav-item active' : 'nav-item'} >
                                <Link href="/how-it-works" onClick={this.howItWorkEnable}>How it Works</Link>
                            </li> */}
                                <li className="nav-item ">
                                    <Link to="/marketing/how-it-works">
                                        How it Works</Link>
                                </li>

                                <li className={(this.state.issearchSpeciality) ? 'nav-item active' : 'nav-item'}>
                                    <Link to='/marketing/for-specialist'
                                    //  onClick={this.goToSpecialistSearch} style={{ cursor: "pointer" }}
                                    >For Specialists</Link>
                                </li>
                                <li className={(this.state.isBlog) ? 'nav-item active' : 'nav-item'} style={{ 'cursor': 'pointer' }}>
                                    <Link to="/marketing/blogs">Blog</Link>
                                </li>
                                <li className="nav-item ">
                                    <Link to="#" onClick={this.openSignUpModal.bind(this, '1')} className="btn btn-primary btn-signup" >Sign Up</Link>
                                </li>
                                <li className="nav-item ">
                                    <Link to="#" onClick={this.openSignInModal.bind(this, '1')} className="btn btn-signin btn-signup" >
                                        <span className="signin-icon">
                                            <img src={require('../../images/images/signin_icon.png')} alt="" />
                                        </span>Sign In</Link>
                                    {this.state.signInModelOpen ?
                                        <Signin {...this.props} openModal={this.state.signInModelOpen} hideSigninModal={this.hideSigninModal} closeSigninOpenSignup={this.closeSigninOpenSignup} openForgotModal={this.openForgotModal} emailToken={this.state.emailToken} otpModal={this.openOtpModal} {...this.props} /> : ''}

                                    {/* <AdminAuth  /> */}
                                    {this.state.otpModalOpen ?
                                        <OtpModal otpModalOpen={this.state.otpModalOpen} loginData={this.state.loginData} closeOtpModal={this.closeOtpModal} {...this.props} /> : ''}

                                    {this.state.signUpModelOpen ?
                                        <Signup {...this.props} show={this.state.signUpModelOpen} hideSignupModal={this.hideSignupModal} closeSignupOpenSignin={this.closeSignupOpenSignin} /> : ''}

                                    {/* <AdminAuth /> */}

                                    {this.state.forgotModalOpen ?
                                        <Forgot forgotModalOpen={this.state.forgotModalOpen} hideForgotModal={this.hideForgotModal} closeForgotModal={this.closeForgotModal} {...this.props} /> : ''}
                                    {this.state.activateAccountModalOpen ?
                                        <ActivateAccount activateModalOpen={this.state.activateAccountModalOpen} closeActivateOpenSigin={this.closeActivateOpenSigin} activationKey={this.state.activationKey} closeActive={this.closeActive} {...this.props} /> : ''}

                                    {this.state.resetModalOpen ?
                                        <ResetPassword resetModalOpen={this.state.resetModalOpen} closeResetOpenSigin={this.closeResetOpenSigin} resetkey={this.state.resetkey} closeReset={this.closeReset}  {...this.props} /> : ''}

                                    {this.state.unLockAccountModalOpen ?
                                        <UnLockAccount unLockModalOpen={this.state.unLockAccountModalOpen} closeUnLockAccountOpenSigin={this.closeUnLockAccountOpenSigin} unLockKey={this.state.unlockKey} closeUnLock={this.closeUnLockAccountModal} {...this.props} /> : ''}
                                    {this.state.unSubscribeEmailModalOpen ?
                                        <UnsubscribeEmails unSubscribeEmails={this.state.unSubscribeEmailModalOpen} closeUnSubscribeOpenSigin={this.closeUnLockAccountOpenSigin} unSubscribekey={this.state.key} closeunSubscribeEmails={this.closeUnsubscribeModal} {...this.props} /> : ''}

                                </li>
                            </ul>
                        </div>
                    </nav>
                    {/* {this.state.isHome ? '' : <Home openSignUp={this.openSignUpModal.bind(this, '1')} {...this.props} />} */}
                    {/* {this.state.isBlog ? <Blog {...this.props} /> : ''} */}
                    <ToastContainer {...this.props}  position="bottom-left" rtl={true}/>


                    {/* er-app-bg blogBg home-banner */}

                    <section className="requirements-hero-bg">
                        <Container fluid>
                            <Row>
                                <Col xs={12} md={6} className="p-left-0 p-right-0" >
                                    <div className="requirements-banner">
                                    </div>
                                </Col>
                                <Col className="requirements-hero" xs={12} md={6} >
                                    <div class="requirements-hero-content">
                                        <h2>Feature your specialty using Medfix</h2>
                                        <p>We're passionate about working with diverse medical professionals who believe in helping patients beyond their own locale. Try managing your clinic using our services.</p>
                                        <div className="bottomBtn text-left">
                                            <button className="btn btn-square btn-w-200"
                                            onClick={this.openSignUpModal.bind(this, '2')}
                                            >
                                                <span className="btn-text">Get Started</span>
                                            </button>
                                        </div>
                                    </div>


                                </Col>
                            </Row>
                        </Container>





                    </section>

                    <section className="requirements-details">
                        <Container fluid>
                            <Row>
                                <Col lg={{ span: 2 }} className='icon-size'>
                                    <span > <FontAwesomeIcon className="fa" size="lg" icon={faClinicMedical} /></span>
                                </Col>
                                <Col lg={8}>
                                    <div className="requirements-para">
                                        <h4>Work with us</h4>
                                        <p>We are committed to helping specialist set-up and maintain their medical practice online. Our digital software equips you to communicate and treat patients on a global scale.
                                       </p>
                                    </div>

                                </Col>
                            </Row>

                            <Row>
                                <Col lg={{ span: 2 }} className='icon-size'>
                                    <span > <FontAwesomeIcon className="fa" size="lg" icon={faUserMd} /></span>
                                </Col>
                                <Col lg={8}>
                                    <div className="requirements-para">
                                        <h4>Minimum Requirements</h4>
                                        <p>Please review minimum requirements needed for specialist account registration.</p>
                                        <ul>
                                            <li>Be of legal age at the time of application (25 years)</li>
                                            <li>Be a medical practitioner with a designated specialty</li>
                                            <li>Be legally allowed to practice medicine in your region</li>
                                            <li>Observe your country laws that regulate medical practice</li>
                                            <li>Do not possess a criminal record or criminal  background</li>
                                            <li>Possess a recognized Medical Degree OR a combination of Certificates, Diplomas, Memberships and Honours that confer professional knowledge and recognize exemplary qualifications and achievements</li>
                                        </ul>
                                        <p>Minimum requirements vary depending on region of practice.
                                       </p>
                                    </div>

                                </Col>
                            </Row>


                            <Row>
                                <Col lg={{ span: 2 }} className='icon-size'>
                                    <span > <FontAwesomeIcon className="fa" size="lg" icon={faIdCard} /></span>
                                </Col>
                                <Col lg={8}>
                                    <div className="requirements-para">
                                        <h4>Required Documents</h4>
                                        <p>Applicants are requested to submit a combination of these general documents. Please refer to your country of practice for a list of specific documents required for your region.</p>
                                        <ul>
                                            <li>Medical College Degree Certificate(s)</li>
                                            <ul>
                                            <li>One (1) of the following:</li>
                                            <ul>
                                                <li>MBBS Degree Certificate (Bachelor of Medicine and Bachelor of Surgery)</li>
                                                <li>Bachelor of Dental Surgery (BDS) Degree Certificate</li>
                                            </ul>
                                            </ul>
                                            <li>Medical or Dental Council License and Registration Number</li>
                                            <li>Recognised Specialty Certificate</li>
                                            <li>Indemnity Insurance (where applicable)</li>
                                            <li>Curriculum Vitae (CV) or résumé with employment history</li>
                                            <li>Proof of Identification</li>
                                            <ul>
                                                <li>One (1) of the following:</li>
                                                <ul>
                                                    <li>Copy of Passport</li>
                                                    <li>Goverment issued valid ID document</li>
                                                </ul>
                                            </ul>
                                        	
                                            <li>Proof of Practicing Clinic</li>
                                            <li>Profile Photo (passport style) </li>
                                            <ul>
                                                <li>Must be forward-facing, centred photo </li>
                                                <li>Must include the specialist full face, and top of shoulders</li>
                                                <li>No sunglasses, unobstructed, no other subjects in the frame </li>
                                                <li>Well-lit, in-focus, high quality</li>
                                                <li>Cannot be a driver’s license or identification card photo</li>
                                                <li>No sunglasses, unobstructed, no other subjects in the frame </li>
                                                <li>Cannot be another printed photo </li>
                                            </ul>
                                        </ul>
                                        <p>Unsure about clinic proof ? Try these alternatives instead:
                                       </p>
                                        <ul>
                                            <li>Letterhead from clinic </li>
                                            <li>Prescription pad signed by clinic owner (signee must hold partial or full ownership of the clinic, shown on the prescription pad)</li>
                                            <li>Proof of clinic or medical practice registration</li>
                                            <li>Clinic or medical practice business tax receipt </li>
                                        </ul>
                                    </div>

                                </Col>
                            </Row>

                            <Row>
                                <Col lg={{ span: 2 }} className='icon-size'>
                                    <span > <FontAwesomeIcon className="fa" size="lg" icon={faUserCheck} /></span>
                                </Col>
                                <Col lg={8}>
                                    <div className="requirements-para">
                                        <h4>Background Verification</h4>
                                        <p>Our Support Team collaborates with trusted vetting agencies to verify your identity and medical background. Verification prevents fraud and ensures patients receive the best care from qualified specialists.</p>
                                        <ul>
                                            <li>Upload the right set of documents by closely reviewing all requirements</li>
                                            <li>Application processing time is 15 to 25 days</li>
                                            <li>For faster approval, submit legitimate, clear and up-to-date documentation</li>
                                            <li>Documents with expiry dates must be updated before the date of expiry</li>
                                        </ul>
                                        <p>Please maintain necessary updates to your contact info, scope of practice, address and clinic hours.
                                        Updated specialist profiles have the best chances of appointment bookings.

                                       </p>

                                    </div>

                                </Col>
                            </Row>
                        </Container>
                    </section>


                    <section className="country-wise-requirements">
                        <Container fluid>
                            <Row>
                            <Col lg={2}>   </Col>
                                <Col lg={8}>
                                    <h2>Country Specific Requirements</h2>
                                    <Tabs
                                        id="country-wise-requirements-tabs"
                                        activeKey={this.state.countryWiseTabkey}
                                        onSelect={this.onTabSelection}
                                    >
                                        <Tab eventKey='bangladesh' title={bangladeshTabTitle}>
                                        <>
											<div id='div1' className="col-md-12 searchHook">
												<div className="panel panel-default">
													<div className="panel-heading" role="tab" id="headingOne">
														<h4 className="panel-title">
															<a id='linkOne' data-toggle="collapse"
																className="collapsed"
																data-parent="#accordion"
																href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
																Background Screening 
        									</a>
														</h4>

													</div>
													<div className="col-md-12" id="lineThrough"></div>
                                                        <div id="collapseOne" className="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                                            <div className="panel-body">
                                                                <div className="requirements-para">
                                                                    <p>In addition to the minimum requirements, please review country-specific requirements before applying 
Applicants should submit a combination of these documents:
</p>
                                                                    <ul>
                                                                        <li>Bangladesh Medical & Dental Council (BM&DC) License and Registration Number</li>
                                                                        <li>One (1) of the following:</li>
                                                                        <ul>
                                                                            <li>Public Service Commission (PSC) Certificate</li>
                                                                            <li>Master of Surgery (MS) in Medicine Certificate</li>
                                                                            <li>Fellow of College of Physicians and Surgeons (FCPS) Medicine Certificate</li>
                                                                        </ul>
                                                                      
                                                                 
                                                                    </ul>
                                                                    <p>New and existing specialists must have passed the background screening as prescribed by the Government of Bangladesh and the Bangladesh Medical Council Act (1973), as and when required.
                                       </p>
                                                                   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

											<div id='div2' className="col-md-12 searchHook">
												<div className="panel panel-default">
													<div className="panel-heading" role="tab" id="headingTwo">
														<h4 className="panel-title">
															<a id='linkTwo' className="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                            Practice Eligibility 
                                                    </a>
														</h4>
													</div>
													<div className="col-md-12" id="lineThrough"></div>
													<div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
														<div className="panel-body">
                                                                <div className="requirements-para">
                                                                    <p>The Bangladesh Medical & Dental Council is a statutory body responsible for establishing the standards of medical education and recognition of medical qualifications in Bangladesh. It regulates the practice of medicine in Bangladesh to protect and promote the health and safety of the public (by ensuring proper standards in medicine).
                                                                     </p>
                                                                
                                                                    <p>Eligibility for medical practice in Bangladesh includes doctors with MBBS qualifications, or MBBS combined with post-graduate degree(s)/diploma(s), or with equivalent qualification(s) in any medical discipline.
                                                                    </p>
                                                                </div>

														</div>
													</div>
												</div>
											</div>

											<div id='div3' className="col-md-12 searchHook">
												<div className="panel panel-default">
													<div className="panel-heading" role="tab" id="headingThree">
														<h4 className="panel-title">
															<a id='linkThree' className="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                            Regulatory Requirements 
                                                     </a>
														</h4>
														<div className="col-md-12" id="lineThrough"></div>
														<div id="collapseThree" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
															<div className="panel-body">
                                                            <div className="requirements-para">
                                                                    <p>Anyone intending or willing to start the onboarding and registration process with Medfix, once having registered onto the platform, and after having met the minimum criteria and eligibility requirements, must adhere to Bangladeshi Regulatory Requirements. This includes all:
                                                                     </p>
                                                                        <ul>
                                                                            <li>Applicable laws</li>
                                                                            <li>Mentioned rules and regulations</li>
                                                                            <li>Orders and all requirements</li>
                                                                            <li>Guidelines and interpretations</li>
                                                                            <li>Directives and Requests from and of, plans, memoranda, agreements with, and of any Regulatory Authority (whether or not they have the force of law)</li>
                                                                        </ul>
                                                                </div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</>
                                        </Tab>
                                        <Tab eventKey="unitedKingdom" title={unitedKingdomTabTitle}>
                                            <a href="#notify-with-email">Become notified when Medfix is available in the UK</a>
                                        </Tab>
                                        <Tab eventKey="india" title={indiaTabTitle}>
                                        <a href="#notify-with-email">Become notified when Medfix is available in the India</a>

                                        </Tab>
                                    </Tabs>

                                </Col>
                                <Col  lg={2}>   </Col>

                      
                            </Row>
                        </Container>
                    </section>


                    <section className="getting-started">
                        <Container fluid>
                        <Row><Col sm={4}><h4>Virtual Healthcare</h4></Col></Row>
                        <Row><Col sm={4}><h3>Getting Started with Medfix</h3></Col></Row>
                        <Row><Col sm={8}><p>Medfix offers an innovative platform digitally enabling you to expand your practice and treat new patients.</p></Col></Row>

                            <Row>
                                <Col sm={12} lg={3}>
                                    <div className="getting-started-section">
                                        <h4>1. Register an Account</h4>
                                        <p>Through the registration page, sign-up for a specialist account.
                                        Review and agree to our Terms and Agreements.
                                       </p>
                                       <Link to="#" onClick={this.openSignUpModal.bind(this, '2')}>
                                       <a href="">Sign up now</a>
                                       </Link>
                                    </div>
                                </Col>
                                <Col sm={12} lg={3}>
                                    <div className="getting-started-section">
                                        <h4>2. Submit Documents </h4>
                                        <p>Upload your medical license and verification requirements onto the dashboard.
                                         For more information on documents specific to your region, see country requirements.
                                       </p>
                                    </div>
                                </Col>
                                <Col sm={12} lg={3}>
                                    <div className="getting-started-section">
                                        <h4>3. Verification and Security</h4>
                                        <p>We’ll conduct security and verification to activate your account.
                                         This includes verifying your identity, background and medical license(s).
 
                                       </p>
                                    </div>
                                </Col>
                                <Col sm={12} lg={3}>
                                    <div className="getting-started-section">
                                        <h4>4. Account Approval</h4>
                                        <p>After meeting verification requirements and passing safety screening, you'll be able to connect to the global patient market in no time.
                                       </p>
                                    </div>
                                </Col>
                             

                            </Row>
                        </Container>
                    </section>


                    <section className="features-and-benefits">
                        <Container fluid>
                            <div className="subheader-container">
                        <Row><Col lg={12}><h4>Specialist-centred tools for optimal productivity</h4></Col></Row>
                        <Row><Col lg={12}><h2>Features & Benefits</h2></Col></Row>
                        <Row><Col lg={12}><p>Let us help you capitalize on your lifetime practice hours. The Medfix solution supports achieving multiple goals while reducing administrative costs.</p></Col></Row>
                        </div>
                            <Row >
                                <Col lg={{ span: 5, offset: 1 }}  className="card-container">
                                    <div className="card">
                                        <Row>
                                            <Col lg={6}>
                                                <div className='card-img-1'>
                                                </div>
                                            
                                            </Col>
                                            <Col  lg={6} className='card-description-parent'> <div className='card-description'>
                                                <h4>Clinic Management Software</h4>
                                                <p>Flexible software for private practice, hospitals or small to medium-sized medical clinics.</p>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col lg={6} className="card-container">
                                    <div className="card">
                                        <Row>
                                            <Col lg={6}>
                                                <div className='card-img-2'>
                                                </div>
                                            </Col>
                                            <Col lg={6} className='card-description-parent'> <div className='card-description'>
                                                <h4>Tools</h4>
                                                <p>Seamless administrative tools to study patient symptoms for in-depth diagnosis.</p>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>

                            </Row>

                            <Row>
                                <Col lg={{ span: 5, offset: 1 }} className="card-container">
                                    <div className="card">
                                        <Row>
                                            <Col lg={6}>
                                                <div className='card-img-3'>
                                                </div>
                                            </Col>
                                            <Col lg={6} className='card-description-parent'> <div className='card-description'>
                                                <h4>Community-focused </h4>
                                                <p>Interact with patients in real time and build personal experiences.</p>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col lg={6} className="card-container">
                                    <div className="card">
                                        <Row>
                                            <Col lg={6}>
                                                <div className='card-img-4'>
                                                </div>
                                            </Col>
                                            <Col lg={6} className='card-description-parent'> <div className='card-description'>
                                                <h4>Efficiency </h4>
                                                <p>Access patient medical history. Write e-prescriptions for virtual consultations.</p>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>

                            </Row>
                        </Container>
                    </section>




                    <section id="notify-with-email" className="request-demo">
                        <Container fluid>
                        <Row><Col md={8}><h3>Getting Started with Medfix</h3></Col>
                   
                        </Row>
                     

                        <Row><Col md={8}><p>Request a free demo to ask questions and get expert answers for a customized experience. </p></Col></Row>
                        <Row><Col lg={{ span: 4, offset: 8 }}>      <div className="demo-btn text-right ">
                                            <button className="btn btn-square btn-w-200"
                                            // onClick={this.submitForVerification}
                                            >
                                                <span className="btn-text">REQUEST A DEMO</span>
                                            </button>
                                        </div></Col></Row>
                        </Container>
                    </section>


                    
                    <section className="email-notification">
                        <Container fluid>
                            <div className="email-notification-body">
                                <Row><Col sm={12} md={12}><h3>To become notified when Medfix is available in your country, enter your email.</h3></Col></Row>
                                <Row>
                                    <Form className="notification-email-wrapper">
                                        <Form.Group controlId="form-notification-email">
                                            <Form.Control type="email" placeholder="your@email.com" />
                                            {/* <Form.Control as="select">
      <option>Bangladesh</option>
      <option>United Kingdom</option>
      <option>India</option>
    </Form.Control> */}
                                        </Form.Group>
                                    </Form>
                                    <ReactFlagsSelect 
                                       searchable={true} 
                                       className="menu-flags"
                                       />
                                </Row>
                              
                                <Row><Col sm={12} md={12}><p>You can unsubscribe at any time.   	<Link to="/marketing/privacy"><span>Read our privacy Policy</span> </Link></p></Col></Row>
                                <Row><Col lg={{ span: 12 }}>      <div className=" text-center">
                                    <button className="btn btn-square notify-me-btn btn-w-120"
                                    // onClick={this.submitForVerification}
                                    >
                                        <span className="btn-text">Notify Me</span>
                                    </button>
                                </div></Col></Row>
                            </div>
                        </Container>
                    </section>





























                    <footer className="text-center colorFooter">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ul className="foterList">
                                        <li className="b-r">
                                            <Link to="#">
                                                <img src={require('../../images/images/footer_logo.png')} className="m-b-15" alt="" />
                                            </Link>
                                            <Link to="/apps">
                                                <img src={require('../../images/images/appstore_footer.png')} className="m-b-10" alt="" />
                                            </Link>
                                            <Link to="/apps">
                                                <img src={require('../../images/images/playstore_Footer.png')} alt="" />
                                            </Link>
                                        </li>
                                        <li className="b-r">
                                            <div className="listCompanyItem">
                                                <h4>Our Company</h4>
                                                <ul className="CompnayList">
                                                    <li>
                                                        <Link to="/marketing/about-us">About us</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/contact-us">Contact Us</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/terms">Terms &amp; Conditions</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/privacy">Privacy Policy</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/quality">Quality &amp; Transparency</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/support-centre">Support Centre</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li className="b-r">
                                            <div className="ft-link-block listCompanyItem">
                                                <h4>For Patients</h4>
                                                <ul className="CompnayList">
                                                    <li>
                                                        <Link to="#" onClick={this.openSignInModal.bind(this, '1')} to="">Sign In</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" onClick={this.openSignUpModal.bind(this, '1')} to="">Sign Up</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#">Find a Specialist </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/#Benifits">Benefits of the ER App</Link>
                                                    </li>
                                                </ul>
                                            </div>

                                        </li>
                                        <li className="b-r">
                                            <div className="ft-link-block listCompanyItem">
                                                <h4>For Specialists</h4>
                                                <ul className="CompnayList">
                                                    <li>
                                                        <Link to="#" onClick={this.openSignInModal.bind(this, '2')} to="">Sign In</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" onClick={this.openSignUpModal.bind(this, '2')} to="">Sign Up</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" href="for-specialist/#Joinus">Why Join Us?</Link>
                                                    </li>

                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="ft-link-block listCompanyItem">
                                                <h4>Apps</h4>
                                                <ul className="CompnayList">
                                                    <li>
                                                        <Link to="/marketing/apps">Patient Android App</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/apps">Patient iOS App</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/apps">Specialists Android App </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/marketing/apps">Specialists iOS App</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div></div>
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <ul className="list-inline social-icon">
                                        <li className="m-5">
                                            <Link to="#">
                                                <i className="fa fa-facebook"></i>
                                            </Link>
                                        </li>
                                        <li className="m-5">
                                            <Link to="#">
                                                <i className="fa fa-twitter"></i>
                                            </Link>
                                        </li>
                                        <li className="m-5">
                                            <Link to="#">
                                                <i className="fa fa-google"></i>
                                            </Link>
                                        </li>
                                        <li className="m-5">
                                            <Link to="#">
                                                <i className="fa fa-pinterest-p"></i>
                                            </Link>
                                        </li>
                                        <li className="m-5">
                                            <Link to="#">
                                                <i className="fa fa-linkedin"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="copyright">
                            <div className="">
                                <div className="">
                                    {/* <p className="copyTxt">Copyright &copy; MyCompany. All rights reserved.</p> */}
                                    <p className="copyTxt">Medfix © 2018. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            }
        </div>
    }
}

export default SpecialistRequirements;